import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { DropdownButton } from 'react-bootstrap';
import * as studyActions from '../../actions/studyActions';
import * as insight360Actions from '../../actions/insight360Actions';
import * as salesCatalystActions from '../../actions/salesCatalystActions';
import * as crosstabActions from '../../actions/crosstabActions';
// import SmartSearch from '../common/SmartSearch/SmartSearch';
import { toastWarning } from '../../util/toastUtils';
import { createWarningMessageObj } from '../../util/preferenceUtils';
import {
  DATA_INPUT_LIST_DUPLICATE_WARNING,
  SAMPLE_VALUE_NULL_ERROR_MESSAGE,
  SC_SAVE_MODIFIED_PACKAGE_LIST,
} from '../../messages/messages';
import { PREFERENCE_SALES_CATALYST, PREFERENCE_SALES_CATALYST_SUBENTITIES,
  PREFERENCE_SMART_SEARCH, SALES_CATALYST, PREFERENCE_STUDY, SC_PACKAGE,
  SMART_SEARCH_SALES_CATALYST_PAGE,
  CROSSTAB_FEATUREID, QUICKREPORTS_FEATUREID, DATAHAUL_FEATUREID, STORIES_FEATUREID,
  BRAND_CATALYST_FEATUREID, SALES_CATALYST_FEATUREID,
 } from '../../constants';
import GenericButton from '../common/GenericButton';
import SmartSearch from '../common/SmartSearch/SmartSearch';
import { getStudyFromStudies, filterStudyList } from '../../util/CommonUtils';
import { saveTrackingData } from '../../util/trackerUtils';

const scSubEntitiesKey = `${PREFERENCE_SALES_CATALYST}.${PREFERENCE_SALES_CATALYST_SUBENTITIES}`;
const scSmartSearchKey = `${PREFERENCE_SALES_CATALYST}.${PREFERENCE_SMART_SEARCH}`;

class PreferencesCommonSmartSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      moduleStudy: undefined,
      componentInfo: {
        studyKey: undefined,
        name: undefined,
      },
      additionalTabInfo: {
        options: [],
        addInputDataPoints: this.addInputDataPointsFn,
      },
      popupApplyVisible: false,
      assignBtnDisabled: true,
    };
    this.smartSearchBox = React.createRef();
  }

  componentDidMount() {
    this.findComponentType();
    this.createAdditionalTabInfo(this.props.modifiedPreferences);
  }

  /* eslint-disable camelcase */
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { modifiedPreferences } = this.props;
    const { componentInfo: { studyKey } } = this.state;
    if (this.props[studyKey] !== nextProps[studyKey]) {
      this.setModuleStudyInfo(nextProps[studyKey]);
    }
    if (!_.isEqual(modifiedPreferences, nextProps.modifiedPreferences)) {
      this.createAdditionalTabInfo(nextProps.modifiedPreferences);
      this.setModuleStudyInfo(undefined, nextProps.modifiedPreferences);
    }
    if (nextProps.kpiInfo !== this.props.kpiInfo) {
      if (nextProps.kpiInfo && nextProps.kpiInfo.intab) {
        this.setState({
          assignBtnDisabled: false,
        });
      } else {
        this.setState({
          assignBtnDisabled: true,
        });
      }
    }
  }

  getModuleStudyInfo = (data, mfdPreference) => {
    const { field, modifiedPreferences } = this.props;
    const defaultStudyKey = `${field.dbKey.split('.')[0]}.${PREFERENCE_STUDY}`;
    const keys = defaultStudyKey.split('.');
    const preferenceData = mfdPreference !== undefined ? mfdPreference : modifiedPreferences;
    const defaultStudyNo = !_.isEmpty(preferenceData) ?
      preferenceData[keys[0]][keys[1]] : undefined;
    if (data !== undefined) {
      let feature = CROSSTAB_FEATUREID;

      if (this.props.field.menuName === 'QuickReports') {
        feature = QUICKREPORTS_FEATUREID;
      } else if (this.props.field.menuName === 'DataHaul') {
        feature = DATAHAUL_FEATUREID;
      } else if (this.props.field.menuName === 'Stories') {
        feature = STORIES_FEATUREID;
      } else if (this.props.field.menuName === 'BrandCatalyst') {
        feature = BRAND_CATALYST_FEATUREID;
      } else if (this.props.field.menuName === 'SalesCatalyst') {
        feature = SALES_CATALYST_FEATUREID;
      }
      const studyList = filterStudyList(data, feature);
      const defaultStudy = getStudyFromStudies(
        studyList,
        defaultStudyNo
      );
      const dsData = defaultStudy || studyList[0].sl[0];
      dsData.wt = 1;
      return dsData;
    }
    return undefined;
  }

  setModuleStudyInfo = (newData, mfdPreference) => {
    const { sessionScreen, scStudy, bcStudy } = this.props;
    const { componentInfo: { studyKey } } = this.state;
    const studyData = newData !== undefined ? newData : _.cloneDeep(this.props[studyKey]);
    let moduleStudy;
    if (sessionScreen && (studyKey === 'bcStudies' || studyKey === 'scStudies')) {
      moduleStudy = studyKey === 'scStudies' ? _.cloneDeep(scStudy) : _.cloneDeep(bcStudy);
    } else {
      moduleStudy = this.getModuleStudyInfo(studyData, mfdPreference);
    }
    this.setState({
      moduleStudy,
    });
  }

  getGridData = () => ({
    kpiInfo: this.props.kpiInfo,
    selectedReport: this.props.selectedReport,
    BaseDataGrid: this.props.BaseDataGrid,
    TargetDataGrid: this.props.TargetDataGrid,
    RecycleElements: this.props.recycleElements,
  });

  createAdditionalTabInfo = data => {
    const { field, defaultSection } = this.props;
    const { additionalTabInfo } = this.state;
    const options = [];
    if (field.options !== undefined && _.isEmpty(options[0])) {
      _.forEach(field.options, o => {
        const keys = o.itemKey.split('.');
        const tempObj = {
          label: o.label,
          min: data !== undefined && !_.isEmpty(data) &&
            data[keys[0]][keys[1]] !== undefined ?
            data[keys[0]][keys[1]].length : 0,
          max: o.count,
          itemKey: o.itemKey,
        };
        if (defaultSection && defaultSection === _.toLower(SC_PACKAGE)) {
          if (tempObj.itemKey === scSubEntitiesKey) options.push(tempObj);
        } else if (tempObj.itemKey !== scSubEntitiesKey) {
          options.push(tempObj);
        }
      });
    }
    this.setState({
      additionalTabInfo: { ...additionalTabInfo,
        options,
      },
    });
  }

  findComponentType = () => {
    const { field } = this.props;
    const componentInfo = {};
    switch (field.menuName) {
      case 'SalesCatalyst':
        componentInfo.studyKey = 'scStudies';
        componentInfo.name = 'salescatalyst';
        break;
      case 'BrandCatalyst':
        componentInfo.studyKey = 'bcStudies';
        componentInfo.name = 'brandcatalyst';
        break;
      default:
        componentInfo.studyKey = 'studies';
        break;
    }

    this.setState({
      componentInfo,
    }, () => {
      this.setModuleStudyInfo();
    });
  }

  addInputDataPointsFn = (data, type) => {
    const keys = type.split('.');
    const { modifiedPreferences } = this.props;
    const tempdata = _.cloneDeep(modifiedPreferences[keys[0]][keys[1]]);
    if (data.sample === 0) {
      toastWarning(SAMPLE_VALUE_NULL_ERROR_MESSAGE);
    } else if (_.find(tempdata,
      o => o.expression === data.expression)) {
      toastWarning(DATA_INPUT_LIST_DUPLICATE_WARNING);
    } else if (tempdata !== undefined) {
      tempdata.push(data);
      this.props.updatePreferences(
        type,
        tempdata
      );
      this.setWarningMessage(undefined, type);
    }
  }

  setWarningMessage = (type, itemKey) => {
    const { field } = this.props;
    if (field.dbKey === scSmartSearchKey && itemKey === scSubEntitiesKey) {
      const warningData = createWarningMessageObj(
        'SalesCatalyst', scSubEntitiesKey, SALES_CATALYST, SC_SAVE_MODIFIED_PACKAGE_LIST, type);
      this.props.setPreferenceWarning(warningData);
    }
  }

    /**
   * common User Preference smart search function
   * for adding selected data points for each options
   * additionalTabInfo.addInputDataPoints exposed through props.
   */
  userPreferenceAddSpecificSelection = type => {
    const { insight360_tags, definationTargetData, selectedCategoryRecType,
      insight360PersonalLabels, expressionFormed,
      } = this.smartSearchBox.current.state;
    this.smartSearchBox.current.handleSelectedIndexState();
    const { defaultSection, scStudy } = this.props;
    let expressionsId = null;
    let definationId = null;
    if (selectedCategoryRecType === 'D') {
      const tagName = _.clone(insight360_tags);
      const object = _.clone(definationTargetData).find(
        obj => obj.title === tagName[0].trimStart(),
      );
      if (!_.isEmpty(object) && typeof object.expressionId !== 'undefined') {
        expressionsId = object.expressionId;
        definationId = object.ovDefinitionId;
      }
    } else {
      expressionsId = null;
      definationId = null;
    }

    this.setState({
      popupApplyVisible: false,
    });

    this.state.additionalTabInfo.addInputDataPoints({
      label: insight360PersonalLabels.join(' '),
      expression: expressionFormed.join(' '),
      sample: this.props.kpiInfo.intab,
      weighted: this.props.kpiInfo.weighted,
      expId: expressionsId,
      defId: definationId,
    },
      type,
    );
    if (defaultSection && defaultSection === _.toLower(SC_PACKAGE)) {
      const { loginResponse, activeAccountId } = this.smartSearchBox.stateProps;
      const { additionalTabInfo } = this.state;
      saveTrackingData({
        uid: loginResponse.data.uid,
        accid: activeAccountId,
        action: SMART_SEARCH_SALES_CATALYST_PAGE,
        moduleName: 'SalesCatalyst',
        subModule: additionalTabInfo && additionalTabInfo.options && additionalTabInfo.options.length > 0 ?
          additionalTabInfo.options[0].label : 'SUB ENTITIES',
        productNo: scStudy !== undefined ?
          scStudy.pn : undefined,
        attributes: { [additionalTabInfo && additionalTabInfo.options && additionalTabInfo.options.length > 0 ?
          additionalTabInfo.options[0].label : 'SUB ENTITIES']: { label: insight360PersonalLabels.join(' '), 
          expression: expressionFormed.join(' ') } },
      });
    }
    this.smartSearchBox.current.resetAll();
    // this.props.gridData.kpiInfo = undefined;
  };

  render() {
    const { crosstabActions } = this.props;
    const { moduleStudy, componentInfo, additionalTabInfo } = this.state;
    return (
      <div>
        <SmartSearch
          selectedModule="userPreferences"
          moduleStudy={moduleStudy}
          getSampleWeighted={crosstabActions.getSampleWeighted}
          fetchKPI={crosstabActions.fetchKPI}
          removeKPI={crosstabActions.removeCrossTabKpiInfo}
          gridData={this.getGridData()}
          dataScreen={componentInfo.name}
          additionalTabInfo={additionalTabInfo}
          ref={this.smartSearchBox}
          isTagInputExpanded
        />
        <div className="move-to-preference-wrapper">
          <div className="insight360-button-group">
            {this.state.assignBtnDisabled ||
              (additionalTabInfo && additionalTabInfo.options.length === 0) ? (
              <div className="display-inline-block">
                <GenericButton
                  name="Assign"
                  btnStyle="i360-smart-search-button create-btn"
                  btnDisabled
                />
              </div>
              ) : (
              <div className="display-inline-block button-group-tooltip i360-smart-search-tooltip">
                {additionalTabInfo && additionalTabInfo.options.length > 1 ?
                  <DropdownButton
                    className="i360-smart-search-button active-btn create-btn"
                    title="Assign"
                    noCaret
                    id="Assign"
                    show={this.state.popupApplyVisible}
                    onToggle={() =>
                      this.setState(prevState => ({
                        popupApplyVisible: !prevState.popupApplyVisible,
                      }))
                    }
                  >
                    {_.map(additionalTabInfo.options, o => {
                      return o.min !== o.max ? (
                        <li
                          key={o.itemKey}
                          onClick={() => this.userPreferenceAddSpecificSelection(o.itemKey)}
                        >{`${o.label} (${o.min}/${o.max})`}</li>
                      ) : (
                        <li key={o.itemKey} className="disabled-item">{`${o.label} (${o.min}/${o.max})`}</li>
                      );
                    })}
                  </DropdownButton> :
                  <GenericButton
                    name="Assign"
                    btnStyle={`i360-smart-search-button ${additionalTabInfo.options[0].min !==
                      additionalTabInfo.options[0].max && 'active-btn'} create-btn`}
                    btnDisabled={additionalTabInfo.options[0].min ===
                      additionalTabInfo.options[0].max}
                    onBtnClick={() =>
                      this.userPreferenceAddSpecificSelection(additionalTabInfo.options[0].itemKey)}
                  />}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

PreferencesCommonSmartSearch.propTypes = {
  field: PropTypes.shape({
    menuName: PropTypes.string,
    style: PropTypes.shape({}),
    defaultValue: PropTypes.shape({}),
    dbKey: PropTypes.string,
    options: PropTypes.shape({}),
  }),
  // studies: PropTypes.arrayOf(PropTypes.shape({})),
  // bcStudies: PropTypes.arrayOf(PropTypes.shape({})),
  // scStudies: PropTypes.arrayOf(PropTypes.shape({})),
  updatePreferences: PropTypes.func,
  setPreferenceWarning: PropTypes.func,
  kpiInfo: PropTypes.shape({
    intab: PropTypes.number,
    weighted: PropTypes.number,
  }),
  modifiedPreferences: PropTypes.shape({}),
  crosstabActions: PropTypes.shape({
    getSampleWeighted: PropTypes.func,   
    fetchKPI: PropTypes.func,   
    removeCrossTabKpiInfo: PropTypes.func,
  }),
  scStudy: PropTypes.shape({
    pn: PropTypes.number
  }),
  bcStudy: PropTypes.shape({}),
  sessionScreen: PropTypes.bool,
  selectedReport: PropTypes.shape({}),
  BaseDataGrid: PropTypes.shape({}),
  TargetDataGrid: PropTypes.shape({}),
  RecycleElements: PropTypes.shape({}),
  recycleElements: PropTypes.shape({}),
  defaultSection: PropTypes.string,
  getSampleWeighted: PropTypes.func,   
  fetchKPI: PropTypes.func,   
  removeCrossTabKpiInfo: PropTypes.func,   
};


function mapStateToProps(state) {
  return {
    studies: state.study.studies,
    bcStudies: state.study.insight360studies,
    scStudies: state.study.salesCatalystStudies,
    scStudy: state.study.salesCatalystStudy,
    bcStudy: state.study.insight360study,
    kpiInfo: state.crosstab.kpiInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    studyActions: bindActionCreators(studyActions, dispatch),
    insight360Actions: bindActionCreators(insight360Actions, dispatch),
    salesCatalystActions: bindActionCreators(salesCatalystActions, dispatch),
    crosstabActions: bindActionCreators(crosstabActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  )(PreferencesCommonSmartSearch);
